import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Loading } from 'uikit/loaders';

import styles from '../styles/courseOutlineLoading.module.scss';

const CourseOutlineLoading = ({ className = '', testId = '' }) => (
  <div className={classNames(styles.element, className)} data-testid={testId}>
    <Loading />
  </div>
);

CourseOutlineLoading.propTypes = {
  className: PropTypes.string,
  testId: PropTypes.string,
};

export default CourseOutlineLoading;
